type EntityWithId = { id: string | number | symbol };

export const createByIds = <Entity extends EntityWithId>(entities: Entity[]) =>
    entities.reduce((byIds, entity) => {
        byIds[entity.id] = entity;
        return byIds;
    }, {});

export const createIds = <Entity extends EntityWithId>(entities: Entity[]) => entities.map(elevator => elevator.id);
